import { useColorMode } from '@chakra-ui/react';
import { t } from 'i18next';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import ArtistIconSelector from '../components/selectors/ArtistIconSelector';
import HomeBottomNav from '../layout/HomeBottomNav';
import HomeHeader from '../presentation/home/components/HomeHeader';
import type { ArtistType } from '../presentation/types/ArtistType';
import OfflineLocationTab from './tabs/OfflineLocationTab';

export default function OfflineLocationPage() {
  const { colorMode } = useColorMode();
  const [selectedArtist, setSelectedArtist] = useState<ArtistType | null>(null);

  const onChangeArtist = (artist: ArtistType | null) => {
    if (!artist) return;
    setSelectedArtist(artist);
  };

  return (
    <div className="pt-[env(safe-area-inset-top)] bg-scroll h-auto min-h-screen dark:bg-background-dark bg-background-light">
      <Helmet>
        <title>{t('tabs.offPan')}</title>
        <meta name="theme-color" content={colorMode === 'dark' ? '#0D0E12' : '#FFFFFF'} />
      </Helmet>
      <HomeHeader />
      {/* @ts-expect-error */}
      <ArtistIconSelector onSelected={onChangeArtist} />
      <hr className="h-[1px] w-full bg-separator1 border-none" />
      {selectedArtist && (
        <OfflineLocationTab
          selectedArtist={{
            artistId: selectedArtist.artistId,
            fandomName: selectedArtist.fandomName
          }}
        />
      )}
      <HomeBottomNav tabIndex={0} className="![filter:none] border-t border-separator1" />
    </div>
  );
}
